export const MessageType = {
    MENU: "MENU",
    TEXT: "TEXT",
    AUDIO: "AUDIO",
} as const;

export const ChatMode = {
    MENU: "MENU",
    LIVE_AGENT: "LIVE_AGENT",
    AI: "AI",
} as const;

export const SenderType = {
    USER: "USER",
    BOT: "BOT",
} as const;

export const API_Status = {
    SUCCESS: "SUCCESS",
    FAILED: "FAILED",
    PENDING: "PENDING",
};

export const SocketTopic = {
    NEW_REQUESTS: (domainId: string) => `/topic/${domainId}/newRequests`,
    ALREADY_ASSIGNED: (domainId: string) =>
        `/topic/${domainId}/already-assigned`,
    ASSIGNED_CHATS: (domainId: string) => `/user/queue/${domainId}/assigned`,
    ERRORS: (domainId: string) => `/user/queue/${domainId}/errors`,
    ACCEPT_CHAT: `/app/chat/accept`,
} as const;

export const Socket_Events = {
    NEW_CHAT: "NEW_CHAT_REQUEST", //new request
    ADMIN_MESSAGE: "ADMIN_MESSAGE", // new user message
    AGENT_MESSAGE: "AGENT_MESSAGE", // new agent message
    INFO: "INFO", // system info notifications etc
    ACCEPT_CHAT: "ACCEPT", // accept chat request
    USER_MESSAGE: "USER_MESSAGE",
    CONNECTED: "CONNECTED",
    ACCEPT_BY_OTHER: "ACCEPTED_BY_OTHER",
    CHAT_ALREADY_ACCEPTED: "CHAT_ALREADY_ACCEPTED",
    AUTO_REJECT: "AUTO_REJECT",
    CUSTOMER_LEFT_CHAT: "CUSTOMER_LEFT_CHAT",
    SESSION_ALREADY_ACTIVE: "SESSION_ALREADY_ACTIVE",
    CONNECTION_TEST: "CONNECTION_TEST",
    AGENT_TYPING: "AGENT_TYPING", // agent is typing
    AGENT_LEFT_CHAT: "AGENT_LEFT_CHAT",
    SUPERVISOR_LIVE_CHAT_NOTIFICATION: 'SUPERVISOR_LIVE_CHAT_NOTIFICATION',
    USER_DELETED: "USER_DELETED",
    NEW_TICKET_NOTIFICATION: "NEW_TICKET_NOTIFICATION",
    TICKET_ASSIGNED_TO_AGENT: "TICEKT_ASSIGNED_TO_AGENT",
    ESCALATE_TO_SUPERVISOR: "ESCALATE_TO_SUPERVISOR",
    TICKET_RESOLUTION_NOTIFICATION: "TICKET_RESOLUTION_NOTIFICATION",
    TICKET_REOPEN_NOTIFICATION: "TICKET_REOPEN_NOTIFICATION"
};

export const Authorities = {
    ADMIN: "ADMIN",
    USER: "USER",
};

export const LANGUAGE_MAP: Record<string, string> = {
    gom: "Konkani",
    mr: "Marathi",
    en: "English",
    hi: "Hindi",
};

export const LANGUAGE_COLOR_MAP: Record<string, string> = {
    en: "bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400",
    hi: "bg-orange-100 text-orange-600 dark:bg-orange-900/30 dark:text-orange-400",
    mr: "bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400",
    gom: "bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400",
};
export type MessageType = (typeof MessageType)[keyof typeof MessageType];
export type SenderType = (typeof SenderType)[keyof typeof SenderType];
export type ChatMode = (typeof ChatMode)[keyof typeof ChatMode];
export type API_Status = (typeof API_Status)[keyof typeof API_Status];
export type SocketTopic = (typeof SocketTopic)[keyof typeof SocketTopic];
export type Socket_Events = (typeof Socket_Events)[keyof typeof Socket_Events];
export type Authorities = (typeof Authorities)[keyof typeof Authorities];

export enum TicketChannel {
    WHATSAPP_CONSOLE = "WHATSAPP_CONSOLE",
    WEBBOT_CONSOLE = "WEBBOT_CONSOLE",
}

